<template>
<div>
    <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Signing In..</p>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="performingRequestForReset" class="loading">
            <p>Creating password reset link..</p>
        </div>
    </transition>

<Navigation ></Navigation>

    <!-- Top Message -->
    <div  class="messageholder">
        <h3 style="text-align:center;color:#fff; padding-top:30px; padding-left:10px; padding-right:10px ">Kegs, Bottles, Cans from your Local Breweries</h3>
        <div style="text-align:center;color:#fff; padding:10px;"><span style="font-size:17px; font-weight:bold">A BREWER AND BUYER COMMUNITY</span></div>
        <!-- Sign up button -->
        <b-container fluid>
            <b-row>
                <b-col cols='12' style="text-align:center; margin-bottom:30px">
                    <b-button class="m-md-2" size="lg" variant="info" @click="toggleForm" style="width:200px;">
                            Join
                        </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
    
    <b-container>
        <!-- Login form -->
        <b-row>
            <b-col cols="12" style="font-size:12px; margin-top:20px; text-align:center"><span>Already have an account?</span></b-col>
        </b-row>
        <form class="container">
            <div class="form-row">
                <div class="input-group col-md-3  col-lg-6 mx-auto" style="margin-top:10px;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Email</span>
                    </div>
                    <input type="email" class="form-control" v-model.trim="loginForm.email"  placeholder="Email" aria-describedby="basic-addon1">
                </div>
                <div class="input-group col-md-3  col-lg-6 mx-auto" style="margin-top:10px;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Password</span>
                    </div>
                    <input type="password" v-model.trim="loginForm.password"  @keyup.enter="login" class="form-control" placeholder="Password" aria-describedby="basic-addon1">
                </div>
            </div>
            <!-- Login and other buttons, only on mobile. Top bar shows it on desktop -->
            <div style="padding-bottom:10px">
                <div style="margin-top:10px; text-align:center; ">
                    <b-button class="m-md-2" variant="info" @click="login">
                        Login
                    </b-button>
                </div>
                <div  style="text-align:center; margin-left:10px; margin-top:20px; ">
                    <div style="color:grey">
                        <a @click="togglePasswordReset">Forgot Password?</a>
                    </div>
                </div>
            </div>
            
        </form>

        <!-- Reset password form -->
        <b-row>
            <b-col>
                <form v-if="showForgotPassword" @submit.prevent class="password-reset" style="margin-bottom:20px">
                    <hr>
                    <div v-if="!passwordResetSuccess" style="margin-top:10px">
                        <h4>Reset Password</h4>
                        <p>We will send you an email to reset your password</p>
                        <div class="input-group" style="margin-top:10px;">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Email</span>
                            </div>
                            <input type="email" class="form-control" v-model.trim="passwordForm.email"  aria-describedby="basic-addon1">
                        </div>

                        <button @click="resetPassword" class="button" style="margin-top:10px">Reset Password</button>
                    </div>
                    <div v-else>
                        <h2>Reset Password Email Link Sent</h2>
                        <h4>Check your email for a link to reset your password</h4>
                    </div>
                    <hr>
                </form>
            </b-col>
        </b-row>

                <!-- Login error message -->
        <b-row>
            <b-col>
                <transition name="fade">
                    <div v-if="errorMsg !== ''" class="error-msg">
                        <p>{{ errorMsg }}</p>
                    </div>
                </transition>
            </b-col>
        </b-row>

        <!-- Keg Seeker Description -->

        <b-row>
            <b-col md="6">
                <b-card bg-variant="light" header-bg-variant="info" text-variant="white" header="CRAFTERS AND DISTRIBUTORS" class="text-center">
                    <b-card-text style="color:black; text-align:left">
                    <h6><span style="font-size:20px; font-weight:bold">SELL ONLINE</span> to Bars, Restaurants, Liquor Stores and more</h6>
                    <h6 style="font-size:14px; padding-left:10px; color:#595959">Use your existing distribution and payment channels</h6>
                    <h6><span  style="font-size:20px; font-weight:bold">CONNECT</span> with Buyers in Your Region</h6>
                    <h6 style="font-size:14px; padding-left:10px; color:#595959">Send newsletters, inventory updates, specials</h6>
                    <h6><span  style="font-size:20px; font-weight:bold">MANAGE</span> your Inventory and Orders</h6>
                    </b-card-text>
                    <div style="text-align:left">
                        <b-button  size="sm" variant="success" @click="toggleForm" style="width:200px;">
                            SELL NOW
                        </b-button>
                    </div>
                </b-card>
            </b-col>
            <b-col>
                <b-card bg-variant="light" header-bg-variant="info" text-variant="white" header="BARS, RESTAURANTS, RETAILERS" class="text-center">
                    
                    <b-card-text style="color:black; text-align:left">
                    <h6><span style="font-size:20px; font-weight:bold">DISCOVER</span> Breweries and Crafters</h6>
                    <h6 style="font-size:14px; padding-left:10px; color:#595959">Find Beers, Kombucha, Seltzer and more</h6>
                    <h6><span  style="font-size:20px; font-weight:bold">INSTANT</span> Prices and Inventory</h6>
                    <h6><span  style="font-size:20px; font-weight:bold">ORDER</span> Online</h6>
                    <div style="font-size:20px; color:#595959">Keg Seeker is FREE for All Buyers</div>
                    </b-card-text>
                    <div style="text-align:left">
                        <b-button size="sm" variant="primary" @click="toggleForm" style="width:200px;">
                            DISCOVER AND BUY
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div style="text-align:center; color:#8c8c8c; font-size:14px">Keg Seeker does not handle delivery or payments. Breweries will use their existing distribution and payment systems</div>
            </b-col>
        </b-row>


        <!-- App icons -->
        <b-row style="margin-top:10px">
            <b-col style="text-align:center">
                <a href="https://apps.apple.com/us/app/kegseeker/id1516879539"><img src="../assets/app_store_icon.png" width="150"></a>
            </b-col>
            <!--
            <b-col style="text-align:center">
                <a href="https://play.google.com/store/apps/details?id=com.kegseeker.kegseeker"><img src="../assets/play_store_icon.png" width="150"></a>
            </b-col>
            -->
        </b-row>
        <!-- About Keg Seeker -->
        <b-row style="margin-top:10px">
            <b-col>
                    Available for iPhone and Android, our app offers an exclusive collection of the best beers, cider, kombucha, seltzers and more.
                <div style='margin-top:10px'>
                        <b-button ><router-link style='text-decoration:none; color:#fff' to="/faq">FAQ</router-link></b-button>
                </div>
            </b-col>
        </b-row>

        <!-- All Beers -->
        <b-row>
            <b-col>
                <allbeersnoauth />
            </b-col>
        </b-row>

        <footer><pagefooter/></footer>
        </b-container>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import {timeConverterDateOnly} from './Myfunctions'
    import Pagefooter from './Pagefooter'
    import Beertable from './Beertable'
    import Allbeersnoauth from './Allbeersnoauth'
    import Navigation from './Navigation.vue'

    export default {
        components: {
            Pagefooter,
            Beertable,
            Allbeersnoauth,
            Navigation
        },
        data() {
            return {
                windowWidth:0,
                loginForm: {
                    email: '',
                    password: ''
                },
                signupForm: {
                    name: '',
                    company: '',
                    email: '',
                    password: '',
                    isbrewer:0,
                    street1:'',
                    street2:'',
                    city:'',
                    state:'',
                    zip:'',
                    radius:'',
                    phone:'',
                    favorites:[]
                },
                passwordForm: {
                    email: ''
                },
                showLoginForm: true,
                showForgotPassword: false,
                passwordResetSuccess: false,
                performingRequest: false,
                performingRequestForReset:false,
                errorMsg: '',
                theUserID: '',
                acceptedTerms:false,
                acceptedPub:false,
                acceptedBrewer:false,
                showTermsWarning:false,
                genericBeersList:[],
                genericBrewersList:[],
            }
        },
        computed: {
            ...mapState(['isBrewer', 'userProfileStatus', 'userProfile', 'allBrewersList', 'allExistingBeers', 'selectedConsumerWebsite', 'allowConsumers', 'countEmails', 'currentUser']),
            beersList(){

            },
            getBreweryData(){
                //var data=["Data 0","Data 1", "Data 2","Data 3","Data 4","Data 5","Data 6","Data 7","Data 8","Data 9"]
                var data = this.allBrewersList
                var componentWidth=120
                var leftColumnWidth=500
                var widthOfDisplay=this.windowWidth-leftColumnWidth
                var columnsInRow=Math.floor(widthOfDisplay/componentWidth)
                var numberOfRows=0
                //Needed to catch columnsInRow=0 on initial load
                if(columnsInRow>0)
                    numberOfRows=Math.ceil(data.length/columnsInRow)
                var rowColumnArray=[]

                //Iterate over all rows
                for (var rowNumber=0; rowNumber<numberOfRows; rowNumber++){
                    //Iterate over columns
                    var columnArray=[]
                    for (var columnNumber=0; columnNumber<columnsInRow; columnNumber++){
                        
                        //Iterate over columns
                        var dataNumber=rowNumber*columnsInRow+(columnNumber)
                        if(dataNumber<data.length){
                            columnArray.push(data[dataNumber])
                        }
                        //End of column array
                    }
                    //Add to row array
                    rowColumnArray.push(columnArray)
                    //End of row array
                }
                return rowColumnArray

            },
        },

        watch: {
            userProfileStatus(newValue, oldValue) {
                /*
                if (newValue){
                    this.performingRequest = false
                    if(this.userProfile.isbrewer==1) this.$router.push('/brewerdashboard')
                    else if(this.userProfile.isbrewer==2) this.$router.push('/distributorinventory')
                    else this.$router.push('/allbeers')
                    
                }*/
            },
        },

        methods: {

            viewBrewerProfile(brewerId,brewer){

                this.$router.push({ path: 'breweryprofile', query: { brewerId: brewerId }})
            },


            toggleForm() {
                this.$router.push({name:'createaccount'})
                this.errorMsg = ''
                //this.showLoginForm = !this.showLoginForm
                
            },
            togglePasswordReset() {
                this.$router.push({path:'/forgotpassword'})
                return
                
                if (this.showForgotPassword) {
                    this.showLoginForm = true
                    this.showForgotPassword = false
                    this.passwordResetSuccess = false
                } else {
                    this.showLoginForm = false
                    this.showForgotPassword = true
                }
            },
            login() {
                this.performingRequest = true
                this.$store.commit('setUserProfileStatus',0)

                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.theUserID = user.user.uid
                        
                }).catch(err => {
                    console.log(err)
                    this.performingRequest = false
                    this.errorMsg = err.message
                })
            },
            resetPassword() {
                this.performingRequestForReset = true

                fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
                    this.performingRequestForReset = false
                    this.passwordResetSuccess = true
                    this.passwordForm.email = ''
                }).catch(err => {
                    console.log(err)
                    this.performingRequestForReset = false
                    this.errorMsg = err.message
                })
            },
            //Exploring beverages without signing in 
            clickedExplore(){
                this.$router.push('/allbeersnoauth')

            },
            onResize() {
                this.windowWidth = window.innerWidth
            },

            //User selected consumer
            selectedConsumer(){
                
                window.open("https://consumer.kegseeker.com", "_blank");
            },
            //User selected business
            selectedBusiness(){
                this.$bvModal.hide("modal-consumer")

            },
        },
        watch: {
            windowWidth(newWidth, oldWidth) {

            }
        },

        mounted(){

            this.$store.dispatch('setAppOptions');

            //For getting logos for first page
            if(this.allBrewersList.length<=0) this.$store.dispatch('fetchAllBrewersList')

            this.windowWidth = window.innerWidth
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })

        },
        beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
        },
        
    }
</script>

<style>
.my-col2{
    border:10px solid white;
    background: linear-gradient(to right, #30A0EE 0%, #30A0EE 50%, #fff 50%, #fff);
}

.loginlefttitle{
    color: white
    
}

.beerTitleFrontPage{
    color:#480000;
}

.beerDescriptionFrontPage{
    color:#F7882F;
}
.accountquestions{
    border:10px solid white;
    background: linear-gradient(to right, #30A0EE 0%, #30A0EE 50%, #fff 50%, #fff);
}

.loginpagecard{
    background:black;
}

.messageholder{
    background-image: url("../assets/tap_handle_blurred2_small.png");
    padding:0px;
    margin:0px;
}

</style>
